import { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { Product, ProductService } from '../api/api_pb';
import { useClient } from '../connect_api';
import { useGlobalContext } from '../GlobalContext';

export function useProductByUuid(productUuid: string | undefined) {
    const location = useLocation();
    const productClient = useClient(ProductService);
    const { findProductByUuid, updateProducts } = useGlobalContext();

    const [product, setProduct] = useState<Product | undefined>(() => {
        return location.state?.product || (productUuid ? findProductByUuid(productUuid) : undefined);
    });
    const [isLoading, setIsLoading] = useState(!product);

    const fetchProduct = useCallback(async () => {
        if (!productUuid) return;
        try {
            const response = await productClient.listProducts({ includeArchived: true });
            const found = response.products.find(p => p.uuid === productUuid);
            if (found) {
                setProduct(found);
                updateProducts(found);
            }
        } catch (error) {
            console.error('Failed to fetch product:', error);
        } finally {
            setIsLoading(false);
        }
    }, [productUuid, productClient, updateProducts]);

    useEffect(() => {
        if (product) {
            setIsLoading(false);
            return;
        }
        fetchProduct();
    }, [product, fetchProduct]);

    return { product, isLoading };
}
